import { FC, useEffect, useState } from 'react'
import { useTypedSelector } from '../../hooks/useTypedSelector'
import { icons } from '../../icons/IconSet'
import { getTiketsVendorIdsFilter, ITicketsFilterOption } from '../../store/ticketsFilterSlice'
import TextButton from '../common/buttom/TextButton'
import DropMenu from '../common/dropmenu/DropMenu'
import Button from '../form/Button'
import Checkbox from '../form/Checkbox'

const TicketVendorsFilter: FC<{
  onResetVendorIds?: () => unknown
  onToggleVendorId?: (id: ITicketsFilterOption['id']) => unknown
  onClearVendorIds?: () => unknown
}> = ({ onResetVendorIds, onToggleVendorId, onClearVendorIds }) => {
  const ticketVendorIdsState = useTypedSelector(getTiketsVendorIdsFilter())
  const [selectedAmount, setSelectedAmount] = useState<number>()

  useEffect(() => {
    setSelectedAmount(() =>
      (ticketVendorIdsState || []).reduce((acc, { isActive }) => acc + (isActive ? 1 : 0), 0),
    )
  }, [ticketVendorIdsState])

  return !ticketVendorIdsState || !ticketVendorIdsState?.length ? null : (
    <DropMenu
      width='238px'
      links={[
        ...ticketVendorIdsState.map(({ id, name, isActive }) => ({
          name: (
            <div
              key={`col-${name}`}
              tabIndex={-1}
              role='button'
              onClick={() => onToggleVendorId && onToggleVendorId(Number(id))}
              className='flex justify-between items-center'
            >
              {name}
              <Checkbox name={`col-${name}`} value={isActive} enablePropagation />
            </div>
          ),
        })),
        {
          name: (
            <div className='flex justify-end gap-4'>
              <TextButton
                type='gray'
                onClick={onClearVendorIds}
                disabled={ticketVendorIdsState?.findIndex(({ isActive }) => isActive) === -1}
                underline
              >
                Clear
              </TextButton>

              <TextButton
                type='gray'
                onClick={onResetVendorIds}
                disabled={ticketVendorIdsState?.length === selectedAmount}
                underline
              >
                Reset
              </TextButton>
            </div>
          ),
        },
      ]}
    >
      <Button
        isNotFullWidth
        type={ticketVendorIdsState?.length !== selectedAmount ? 'submit' : 'button'}
        className='whitespace-nowrap flex gap-2 items-center font-normal pl-3 pr-3 pt-1 pb-1'
      >
        Vendors
        {ticketVendorIdsState?.length !== selectedAmount && (
          <div>
            {selectedAmount}
            <span className='text-[80%]'> / </span>
            {ticketVendorIdsState.length}
          </div>
        )}
        {icons('chevron-down', { width: '14px' })}
      </Button>
    </DropMenu>
  )
}

export default TicketVendorsFilter
